import { ResourceType, SearchResourceInput } from '@mxa-argos/core/graphql/graphql';
import gql from 'graphql-tag';

const SEARCH_RESOURCE_QUERY = gql`
  query Resources($input: SearchResourceInput!) {
    resources(input: $input) {
      type
      id
      primaryText
      secondaryText
      tertiaryText
      quaternaryText
    }
  }
`;

export const buildSearchResourcesQuery = (
  searchString: string,
  types: ResourceType[] = [],
): {
  operation: 'resources';
  gqlQuery: typeof SEARCH_RESOURCE_QUERY;
  variables: { input: SearchResourceInput };
} => ({
  operation: 'resources',
  gqlQuery: SEARCH_RESOURCE_QUERY,
  variables: {
    input: {
      searchString,
      types,
    },
  },
});
